// removed by extract-text-webpack-plugin
module.exports = {"rrssContainer__defaultStyle":"rrssContainer__defaultStyle","rrssContainer__iconOpen":"rrssContainer__iconOpen","rrssContainer__iconList":"rrssContainer__iconList","rrssContainer__iconList__elem":"rrssContainer__iconList__elem","rrssContainer__iconList__elem__icon":"rrssContainer__iconList__elem__icon","open":"open"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ComLabRRSS/comLabRRSS.scss
// module id = 563
// module chunks = 0